module.exports = __webpack_public_path__ + "media/images/thumbs/pathophys/2EO53ORJwj4f5ELSp3DO38-0ee2f0b52a8ec992494682512f95ea1d.jpg";